import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Select } from 'gu-ui-kit'
import isObject from 'lodash/isObject'

const SelectComponent = ({ label = '', name, filterManager }) => {
  const { filters, updateFilter, configuration } = filterManager
  const { t } = useTranslation()
  const value = useMemo(() => filters?.[name] || [], [filters])

  const optionLabelPrefix = useMemo(
    () => configuration?.[name]?.optionLabelPrefix || '',
    [configuration, name],
  )

  const componentConfig = useMemo(
    () => configuration?.[name] || {},
    [configuration, name],
  )

  const options = useMemo(
    () =>
      componentConfig.options.map((option) => {
        const { label, value } = isObject(option)
          ? option
          : { label: t(optionLabelPrefix + option), value: option }

        return { label, value }
      }),
    [componentConfig, optionLabelPrefix, t],
  )

  return (
    <Select
      {...componentConfig}
      value={value}
      options={options}
      showEmptyOption={
        componentConfig.showEmptyOption || !componentConfig.multiple
      }
      label={t(label)}
      emptyOptionLabel={t(componentConfig.emptyOptionLabel)}
      checked={value}
      onChange={(update) => updateFilter({ fieldName: name, value: update })}
    />
  )
}

SelectComponent.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  filterManager: PropTypes.object,
}

export default SelectComponent
